import { combineReducers, configureStore, applyMiddleware, compose } from "@reduxjs/toolkit";

import alarmsSlice from "./alarmsSlice";
import configurationSlice from "./configurationSlice";
import devicesSlice from "./devicesSlice";
import deviceGroupsSlice from "./deviceGroupsSlice";
import customDashboardsSlice from "./customDashboardsSlice";
import profileSettingsSlice from "./profileSettingsSlice";
import billingInfoSlice from "./billingInfoSlice";
import meteringDashboardSlice from "./meteringDashboardSlice";
import feedsSlice from "./feedsSlice";
import usersSlice from "./usersSlice";
import processedDataSlice from "./processedDataSlice";
import weatherSlice from "./weatherSlice";
import { APIStatus } from "./APIStatus";
import organizationsSlice from "./organizationsSlice";
import feedRulesSlice from "./feedRulesSlice";
import triggersSlice from "./triggersSlice";
import commentsSlice from "./commentsSlice";
import resetPasswordSlice from "./resetPasswordSlice";
import assetSlice from "./assetSlice";
import edmDashboardSlice from "./edmDashboardSlice";
import diagnosticsSlice from "./diagnosticsSlice";
import rEyeDashboardSlice from "./rEyeDashboardSlice";
import keplerGlReducer, {enhanceReduxMiddleware} from 'kepler.gl/reducers';
import {taskMiddleware} from 'react-palm/tasks';

const rootReducer = (state, action) => {
  if (action.type === APIStatus.closeSession) {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const customizedKeplerGlReducer = keplerGlReducer.initialState({
    uiState: {
      currentModal: null,
      // customize which map control button to show
      mapControls: {
        visibleLayers: {
          show: false,
          active: true
        },
        mapLegend: {
          show: true,
          active: true
        },
        toggle3d: {
          show: false
        },
        splitMap: {
          show: false
        }
      }
    }
  });

const combinedReducer = combineReducers({
  keplerGl: customizedKeplerGlReducer,
  assetSlice: assetSlice,
  devicesSlice: devicesSlice,
  deviceGroupsSlice: deviceGroupsSlice,
  feedsSlice: feedsSlice,
  usersSlice: usersSlice,
  processedDataSlice: processedDataSlice,
  triggersSlice: triggersSlice,
  alarmsSlice: alarmsSlice,
  weatherSlice: weatherSlice,
  configurationSlice: configurationSlice,
  organizationsSlice: organizationsSlice,
  feedRulesSlice: feedRulesSlice,
  resetPasswordSlice: resetPasswordSlice,
  commentsSlice: commentsSlice,
  customDashboards: customDashboardsSlice,
  profileSettingsSlice: profileSettingsSlice,
  billingInfoSlice: billingInfoSlice,
  meteringDashboardSlice: meteringDashboardSlice,
  edmDashboardSlice: edmDashboardSlice,
  diagnosticsSlice: diagnosticsSlice,
  rEyeDashboardSlice: rEyeDashboardSlice,
});


export const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(taskMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});
